import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
// @ts-ignore
import Tooltip from "vue-directive-tooltip";
import "vue-directive-tooltip/css/index.css";

import axios from 'axios';

Vue.use(Tooltip);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

axios.interceptors.request.use((config) => {
        const {isLogged, token} = store.state['user'];

        if (isLogged) {
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    (err) => {
        //What do we do when we get errors?
    });

let v = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");



